import Container from 'react-bootstrap/Container';
import FilterBar from './filterBar';
import ReportViewer from '../../components/Reporting/ReportViewer';
import { reportComponentRegistry } from './reportComponentRegistry';

export default function ReportPage({
    selectedReport,
    filters,
    setFilters,
    dynamicOptions,
    schema,
    data,
}) {
    if (!selectedReport) return null;

    const headerKey = selectedReport?.layout?.headerKey;
    const HeaderComponent = headerKey
        ? reportComponentRegistry.headers[headerKey] || null
        : null;
    const showFilters = selectedReport?.layout?.showFilters !== false && !!selectedReport.filters;

    return (
        <Container fluid className="p-0">
            <div className="mb-3">
                <h4 className="mb-1">{selectedReport.title}</h4>
                {selectedReport.description ? (
                    <div className="text-muted small">{selectedReport.description}</div>
                ) : null}
            </div>

            {HeaderComponent ? (
                <div className="mb-3">
                    <HeaderComponent
                        selectedReport={selectedReport}
                        filters={filters}
                        setFilters={setFilters}
                        data={data}
                    />
                </div>
            ) : null}

            {showFilters ? (
                <div className="mb-3">
                    <FilterBar
                        filters={filters}
                        setFilters={setFilters}
                        reportConfig={selectedReport}
                        dynamicOptions={dynamicOptions}
                    />
                </div>
            ) : null}

            <ReportViewer
                selectedReport={selectedReport}
                filters={filters}
                schema={schema}
                data={data}
            />
        </Container>
    );
}